import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { MicInterruptReason } from '../services/AudioRecorderService';
import MicrophoneMonitor from './MicrophoneMonitor';

const MicInterruptBanner = ({
  reason,
  preferredDeviceId,
  onDeviceReady,
  onResume,
  resumeLoading
}) => {
  let title = 'Microphone disconnected';
  let message = 'Your microphone was interrupted or disconnected. Select a microphone and resume to continue.';
  if (reason === MicInterruptReason.SILENCE) {
    title = 'No audio detected';
    message = 'Your microphone appears connected but is not sending audio. Check the device, then resume.';
  } else if (reason === MicInterruptReason.BACKGROUND) {
    title = 'Recording paused';
    message = 'Recording was paused because you left this consultation. Resume to continue.';
  }

  return (
    <div className="mic-interrupt-banner" role="alert">
      <div className="mic-interrupt-banner-text">
        <strong>{title}</strong>
        <p>{message}</p>
      </div>
      <div className="mic-interrupt-banner-actions">
        <MicrophoneMonitor
          mode="recovery"
          active
          preferredDeviceId={preferredDeviceId}
          onReady={onDeviceReady}
          onDeviceChange={(id) => onDeviceReady?.({ deviceId: id, canRecord: true })}
          showSilenceHint
        />
        <button
          type="button"
          className="header-button header-button-primary mic-interrupt-resume"
          onClick={onResume}
          disabled={resumeLoading}
        >
          {resumeLoading ? <FontAwesomeIcon icon={faSpinner} spin /> : 'Resume Recording'}
        </button>
      </div>
    </div>
  );
};

export default MicInterruptBanner;
